// Size Chart image Tab Switcher
document.addEventListener("click", function (e) {
  if (!e.target.classList.contains("size-tab")) return;

  const wrapper = e.target.closest(".size-chart-content");
  const tabs = wrapper.querySelectorAll(".size-tab");
  const panels = wrapper.querySelectorAll(".size-panel");

  // Remove active
  tabs.forEach((tab) => tab.classList.remove("active"));
  panels.forEach((panel) => panel.classList.remove("active"));

  // Add active to clicked tab
  e.target.classList.add("active");

  const selected = e.target.dataset.tab;
  wrapper.querySelector(`[data-panel="${selected}"]`).classList.add("active");
});

// Collapsible Toggle Plus/Minus Sync
document.addEventListener("click", function (e) {
  const toggle = e.target.closest(".collapsible-toggle");
  if (!toggle) return;

  // Function to sync icons for all toggles
  const syncAllIcons = () => {
    document.querySelectorAll(".collapsible-toggle").forEach((el) => {
      const isExpanded = el.getAttribute("aria-expanded") === "true";
      const plusIcon = el.querySelector(".icon--plus");
      const minusIcon = el.querySelector(".icon--minus");

      if (plusIcon && minusIcon) {
        if (isExpanded) {
          plusIcon.classList.add("hidden");
          minusIcon.classList.remove("hidden");
        } else {
          plusIcon.classList.remove("hidden");
          minusIcon.classList.add("hidden");
        }
      }
    });
  };

  // Sync icons after a short delay to allow theme JS to update attributes
  setTimeout(syncAllIcons, 10);
  // Also sync after a longer delay for animations
  setTimeout(syncAllIcons, 500);
});

// Initial state sync for collapsibles
document.addEventListener("DOMContentLoaded", function () {
  const syncAllIcons = () => {
    document.querySelectorAll(".collapsible-toggle").forEach((el) => {
      const isExpanded = el.getAttribute("aria-expanded") === "true";
      const plusIcon = el.querySelector(".icon--plus");
      const minusIcon = el.querySelector(".icon--minus");

      if (plusIcon && minusIcon) {
        if (isExpanded) {
          plusIcon.classList.add("hidden");
          minusIcon.classList.remove("hidden");
        } else {
          plusIcon.classList.remove("hidden");
          minusIcon.classList.add("hidden");
        }
      }
    });
  };
  syncAllIcons();
});

// Measurement Guide Sync Function
// Size Chart Tab Switcher
document.addEventListener("click", function (e) {
  const tab = e.target.closest(".size-tab");
  if (!tab) return;

  const wrapper = tab.closest(".size-chart-content");
  if (!wrapper) return;

  const tabs = wrapper.querySelectorAll(".size-tab");
  const panels = wrapper.querySelectorAll(".size-panel");

  // Remove active
  tabs.forEach((t) => t.classList.remove("active"));
  panels.forEach((p) => p.classList.remove("active"));

  // Activate clicked tab
  tab.classList.add("active");

  const selected = tab.dataset.tab;
  const activePanel = wrapper.querySelector(`[data-panel="${selected}"]`);

  if (activePanel) {
    activePanel.classList.add("active");
  }
});

// Sync size chart radios across tabs (inches <-> cm)
document.addEventListener("change", function (e) {
  if (e.target.classList.contains("sc-radio")) {
    const variantId = e.target.value;

    document
      .querySelectorAll(`.sc-radio[value="${variantId}"]`)
      .forEach((radio) => {
        radio.checked = true;
      });
  }
});

document.addEventListener("click", function (e) {
  const button = e.target.closest(".size-switch-btn");
  if (!button) return;

  // Parent container
  const container =
    button.closest(".drawer") ||
    button.closest("popover-content") ||
    document;

  // Buttons
  const buttons = container.querySelectorAll(".size-switch-btn");

  buttons.forEach((btn) => {
    btn.classList.remove("active");
  });

  button.classList.add("active");

  // Sections
  const targetId = button.dataset.target;

  const targetSection =
    container.querySelector("#" + targetId) ||
    container.querySelector("." + targetId);

  if (!targetSection) return;

  const allSections = container.querySelectorAll(".size-switch-section");

  // Hide all sections
  allSections.forEach((section) => {
    section.classList.add("hidden");
    section.style.display = "none";
  });

  // Show active section
  targetSection.classList.remove("hidden");
  targetSection.style.display = "block";
});

function updateSizeChartButtons(container = document) {
    const checkedSwatch = container.querySelector(".block-swatch__radio:checked");
    const sizeChartButtons = container.querySelectorAll(".size-chart-btn.add-to-cart");

    sizeChartButtons.forEach((btn) => {
        if (checkedSwatch) {
            btn.classList.remove("hidden");
        } else {
            btn.classList.add("hidden");
        }
    });
}

// Initial state on load
document.addEventListener("DOMContentLoaded", function () {
    updateSizeChartButtons();
});

// Update when size swatch changes
document.addEventListener("change", function(e) {
    if (e.target.classList.contains("block-swatch__radio")) {
        const container = e.target.closest(".drawer") || e.target.closest("popover-content") || document;
        updateSizeChartButtons(container);
    }
});

document.addEventListener("click", function (e) {
    const btn = e.target.closest(".size-chart-btn.add-to-cart");
    if (!btn) return;
    
    const container = btn.closest(".drawer") || btn.closest("popover-content") || document;
    let realAddToCart = null;

    // Try to find the exact product form based on the selected size in the drawer
    const activeRadio = container.querySelector(".custom-size-chart-radio:checked");
    if (activeRadio) {
        const variantId = activeRadio.dataset.variantId;
        const swatch = document.querySelector(`.block-swatch__radio[data-option-variant-id="${variantId}"]`);
        if (swatch) {
            const productForm = swatch.closest("form");
            if (productForm) {
                realAddToCart = productForm.querySelector('[type="submit"], #AddToCart, .custom-addToCart');
            }
        }
    }

    // Fallback if not found
    if (!realAddToCart) {
        realAddToCart = document.querySelector("#AddToCart");
    }

    if (realAddToCart) {
        realAddToCart.click();
    }

    // Close drawer / popover after add to cart
    setTimeout(() => {
        const closeContainer =
            btn.closest("drawer-content") ||
            btn.closest("popover-content") ||
            btn.closest(".drawer");

        if (!closeContainer) return;

        const closeBtn = closeContainer.querySelector('[data-action="close"]');

        if (closeBtn) {
            closeBtn.click();
        }
    }, 100);

});

// PDP Product Information bloack drawer tab switcher
// PDP + Quick View Product Information Drawer Tabs

document.addEventListener('click', function (e) {

  // USP buttons outside drawer
  const triggerButton = e.target.closest('.product_usb-button');

  if (triggerButton) {
    const tabName = triggerButton.dataset.tab;

    activateTab(tabName, triggerButton);

    return;
  }

  // Tabs inside drawer
  const tabButton = e.target.closest('.product-tab');

  if (tabButton) {
    const tabName = tabButton.dataset.tab;

    activateTab(tabName, tabButton);
  }

});

function activateTab(tabName, clickedElement) {

  // Find the nearest drawer context
  const container =
    clickedElement.closest('quick-buy-popover') ||
    document;

  // Remove active classes
  container.querySelectorAll('.product-tab').forEach((tab) => {
    tab.classList.remove('active');
  });

  container.querySelectorAll('.drawer-tab').forEach((content) => {
    content.classList.remove('active');
  });

  // Activate tab button
  const activeTab = container.querySelector(
    `.product-tab[data-tab="${tabName}"]`
  );

  if (activeTab) {
    activeTab.classList.add('active');
  }

  // Activate content
  const activeContent = container.querySelector(
    `.drawer-tab[data-content="${tabName}"]`
  );

  if (activeContent) {
    activeContent.classList.add('active');
  }

}